<div class="toolbar-button pin-button" (click)="togglePin()">
    <vn-icon size="16" [name]="isPinned ? 'theme-pin-pinned' : 'theme-pin-unpinned'" />
    <div class="button-label">{{ pinText }}</div>
</div>
